<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="addCateConfig.isOpen"
    id="add-category"
  >
    <div class="mt-3 flex items-center justify-between px-6">
      <h4 class="font-bold text-2xl">Add New Category</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div class="sidebar-content p-6">
      <!-- <div class="add-category-avatar-container">
        <h4 class="text-lg font-bold">Category image</h4>
        <avatar-uploader class="my-avatar-uploader" :isFromService="true" v-if="addCateConfig.isOpen" :user="avatarData" @uploaded-done="handleUploaded"></avatar-uploader>
      </div> -->
      <div>
        <!-- <label class="text-sm mb-2 d-inline-block">Category Name</label> -->
        <h4 class="font-bold text-lg mt-6 mb-4">Category name</h4>
        <vs-input v-validate="'required'" name="category_name" placeholder="Category Name" v-model="category_name" class="w-full" :danger="errors.has('category_name')"
              danger-text="The category name field is required" @input="add_is_exist=false" v-on:keypress="formatName" />
        <span class="text-danger text-xs error-text-input" v-show="add_is_exist">{{errMessage}}</span>
      </div>
      <div class="pt-base">
        <!-- <label class="text-sm mb-2">Category color</label> -->
        <h4 class="font-bold text-lg mb-3">Category color</h4>
        <ul class="clearfix flex flex-wrap">
          <!-- Color Square -->
          <li
            v-for="(color, index) in themeColors"
            :key="color"
            :style="{backgroundColor: color}"
            class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left position-relative"
            @click="updatePrimaryColor(color)"
            :class="{'blur-item': isNewColor || (index >= 0 && index < 20)}"
          >
          <i class="vs-icon material-icons text-white font-bold text-2xl translate-center" v-if="color == primaryColor">check</i>
          </li>

          <!-- Custom Color Square -->
          <!-- <li
            :style="{backgroundColor: customColor}"
            :class="{'shadow-outline': customColor == primaryColor}"
            class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left position-relative"
            @click="updatePrimaryColor(customColor)"
          >
          <i class="vs-icon material-icons text-white font-bold text-2xl translate-center" v-if="customColor == primaryColor">check</i>
          </li>

          <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2" v-model="customColor" type="color" /></li> -->
        </ul>
      </div>
    </div>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" @click="submitData" style="min-width: 140px">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeSidebar" style="min-width: 140px">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  name: "vs-add-category",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue")
  },
  props: {
    addCateConfig: {
      type: Object,
      required: true
    },
    serviceData: {
      type: Object,
      required: true
    },
    currentPage:{
      type: Number,
      required: true
    },
    isExistName:{
      type: Boolean,
      required: true
    },
    errMessage: {
      type: String,
      default: ''
    }
  },
  data() {
      return {
          number0: 0,
          category_name : "",
          itemsPerPage: 10,
          is_exist: this.isExistName,
          themeColors: this.$store.getters["staffList/themeColorsCate"],
          currentColor: this.$store.getters["staffList/themeColorsCate"][0],
          customColor: "#FF9CBB",
          image: {
            image_url: null,
            delete_image_url: null,
            image_path: null,
            image_base_url: null
          },
          avatarData: {
            name: this.category_name,
            color_code: this.primaryColor,
            image_url: this.image
          },
      }
  },
  computed: {
      add_is_exist: {
          get() { return this.is_exist; },
          set(value)
          {
            this.is_exist = value;
          }
      },
      primaryColor: {
        get() {
          return this.currentColor;
        },
        set(value) {
          this.currentColor = value;
        }
      },
      config() {
        return this.$store.getters["auth/config"];
      },
      isNewColor() {
        return this.config && this.config.new_color == 1;
      }
  },
  watch: {
    addCateConfig: {
      immediate: true,
      deep: true,
      handler() {
        // this.category_name = '';
        this.errors.clear();
        this.primaryColor = this.themeColors[0];
        if(this.addCateConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        } else {
          document.body.classList.remove('overflow-hidden');
          this.category_name = '';
          this.$emit("CloseSidebar");
        }
      }
    }
  },
  methods: {
    handleUploaded(data) {
      this.image = data;
    },
    removeAccents(str) {
      return str.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/đ/g, 'd').replace(/Đ/g, 'D');
    },
    formatName() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.category_name = this.removeAccents(this.category_name);
      }, 500);
    },
    updatePrimaryColor(color) {
      this.primaryColor = color;
      // this.$vs.theme({ primary: color });
    },
    closeSidebar() {
      this.$emit("CloseSidebar");
    },
    submitData(){
      if(this.category_name != ''){
        if(this.category_name.toLowerCase().trim() == 'other'){
          this.$vs.notify({
            title:'Notification',
            text:'Other has already existed',
            color:'danger',
            position:'top-right'})
        }else{
          const obj = {
          name: this.removeAccents(this.category_name),
          color_code: this.primaryColor,
          // image_path: this.image.image_path,
          // image_base_url: this.image.image_base_url
          // page: this.$store.getters["serviceList/categoryList"]._meta.totalCount % 10 == 0 ?
          // this.$store.getters["serviceList/categoryList"]._meta.pageCount + 1 :
          // this.$store.getters["serviceList/categoryList"]._meta.pageCount,
          // "per-page": this.itemsPerPage
        }
          this.$emit("SubmitData", obj);
        }
      }
      this.$validator.validateAll();
    },
  }
};
</script>
